import { Directive, ElementRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'environment';
import * as JWT from 'jwt-decode';
const LS_TOKEN = 'token';
const envName = environment.name;


@Directive({
  selector: '[appPermission]'
})
export class PermissionDirective implements OnInit {
  private permissions;
  private environments;
  private isHidden = true;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
  }

  ngOnInit() {
    this.updateView();
  }

  @Input()
  set appPermission(permission: { roles: string[], env: string[] }) {
    this.permissions = permission.roles;
    this.environments = permission.env;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private checkPermission() {

    const token: string = localStorage.getItem(LS_TOKEN);
    const decodedToken: any = token && JWT(token);
    const currentRole: string = decodedToken.role;

    if (this.permissions && this.environments) {
      return this.permissions.indexOf(currentRole) > -1 && this.environments.indexOf(envName) > -1 ? true : false;
    }

    if (this.permissions) {
      return this.permissions.indexOf(currentRole) > -1 ? true : false;
    } else {
      return this.environments.indexOf(envName) > -1 ? true : false;
    }
  }

}
